import React, { useState } from 'react';
interface BookImageProps {
  className?: string;
  /** Rendered size context; only affects the CSS fallback proportions. */
  emblem?: boolean;
}

/**
 * Generic navy book art (no client branding). Prefers the public asset at
 * /book-generic-navy.png — Magic Patterns remaps root public files to CDN,
 * but often misses nested /proof/ paths with spaces.
 */
export function BookImage({
  className = '',
  emblem = true
}: BookImageProps) {
  const [hasImage, setHasImage] = useState(true);
  if (hasImage) {
    return <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/67ed1325-767e-4f35-bd1c-b49fa7a310ff/book-generic-navy.png" alt="An expert nonfiction book" onError={() => setHasImage(false)} className={`object-contain drop-shadow-[0_28px_40px_-20px_rgba(0,0,0,0.55)] ${className}`} data-id="element-578" data-mp="2pe1d3wah2cmk" />;
  }
  return <div className={`relative aspect-[3/4] w-[10.5rem] md:w-[13.5rem] ${className}`} aria-hidden="true" data-id="element-579" data-mp="26n0i1jch318a">
      <div className="relative h-full w-full rotate-[-4deg] rounded-l-sm rounded-r-md bg-gradient-to-br from-[#243447] to-[#1a2838] shadow-[0_30px_60px_-25px_rgba(0,0,0,0.65)] ring-1 ring-white/15" data-id="element-580" data-mp="2ynxgypaqx838">
        <div className="absolute left-0 top-0 h-full w-[7%] rounded-l-sm bg-black/35" data-id="element-581" data-mp="2pvls37va5spd" />
        <div className="absolute right-[-5px] top-[5%] h-[90%] w-[4%] rounded-r-sm bg-[#faf8f5]/90" data-id="element-582" data-mp="2kwscn9wfnrmk" />
        <div className="absolute bottom-[-3px] left-[8%] right-[2%] h-[3%] rounded-b-sm bg-[#f5f3f0]/85" data-id="element-583" data-mp="2fxo3gj9idtw8" />
        {emblem && <div className="absolute left-1/2 top-1/2 flex aspect-square w-[38%] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[#a8c4bb]/50" data-id="element-584" data-mp="2ay362d9zltlm">
            <div className="h-[45%] w-[55%] rounded-b-[10px] border-b-[3px] border-l-[3px] border-r-[3px] border-[#d4a574]/85" data-id="element-585" data-mp="21xwly8js9vdh" />
          </div>}
      </div>
    </div>;
}